import { SelectorProps } from '@web-chat-core/ui-kit';
import { StyledSelector } from './view';

export const Selector = (props: SelectorProps) => <StyledSelector {...props} />;

Selector.displayName = 'Selector';
